export enum POSITION_MODE {
  READ,
  SELECT,
}
